module.exports = __webpack_public_path__ + "static/img/App item-2.cdea958.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls39/App item-2.png
// module id = aqTH
// module chunks = 12